export const QUERY_IDS = {
  GET_ELIGIBILITIES: 'getEligibilities',
}
